import { render, staticRenderFns } from "./FotosYVideos.vue?vue&type=template&id=99b479a6"
import script from "./FotosYVideos.vue?vue&type=script&lang=js"
export * from "./FotosYVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports